import { BannerCard } from '@design-system';
import { isAbsoluteUrl, isValidUrl } from '@utils/urlHelpers';
import classNames from 'classnames';
import { useCallback } from 'react';

import { BannerListStoryblok } from '../types/generated-storyblok';
import { useAnalyticsEmitter } from '../utils/analytics/emitter';

interface ContentBlockBannerListProps {
  blok: BannerListStoryblok;
}

export const ContentBlockBannerList = ({
  blok,
}: ContentBlockBannerListProps) => (
  <div className="grid grid-cols-4 justify-center gap-x-5 gap-y-6 xl:flex xl:flex-wrap">
    {blok.items.map((item, index) => {
      const [emitter] = useAnalyticsEmitter();

      const handleClick = useCallback(() => {
        emitter('', 'banner clicked', {
          'link url': item.link.cached_url,
          'link title': item.title,
          'is external': false,
        });
      }, [item, emitter]);

      const isLastItem = index === blok.items.length - 1;
      const itemClasses = classNames(
        blok.items.length === 1
          ? 'col-span-full w-full xl:max-w-2xl 2xl:max-w-5xl'
          : 'col-span-full md:col-span-2 w-full xl:max-w-xl 2xl:max-w-2xl',
        {
          'md:col-start-2':
            isLastItem &&
            blok.items.length % 2 !== 0 &&
            blok.items.length !== 1,
        },
      );

      const linkUrl = item.link?.cached_url || '';
      const isAbsolute = isAbsoluteUrl(linkUrl);
      const isValidLink = isValidUrl(isAbsolute ? linkUrl : `/${linkUrl}`);

      return (
        <div key={blok._uid} className={itemClasses}>
          {isValidLink ? (
            <BannerCard
              as="a"
              aspectRatioClassName="aspect-[4/3]"
              hasLargeTitle
              href={isAbsolute ? linkUrl : `/${linkUrl}`}
              image={item.image}
              onClick={handleClick}
              pillLabel={item.type}
              target={item.link.target}
              title={item.title}
              variant="image"
            />
          ) : (
            <BannerCard
              as="a"
              aspectRatioClassName="aspect-[4/3]"
              hasLargeTitle
              href="#"
              image={item.image}
              pillLabel={item.type}
              title={item.title}
              variant="image"
            />
          )}
        </div>
      );
    })}
  </div>
);
